module.exports = __webpack_public_path__ + "img/main_culture2.4319890e.png";